import CommonStore from '@vue3/store/common-store.js'
import AuthStore from '@vue3/store/auth-store.js'
import AgreementStore from '@vue3/store/agreement-store'

export function listenEventFromVuexToPinia () {
  window.addEventListener('update.pinia.state.from.vuex', ({ detail }) => {
    const { eventType, data } = detail
    const eventHandlers = {
      VUEX_APP_LOADER: () => CommonStore().setAppLoaderFromVuex(data),
      VUEX_IS_LOGGED_IN: () => AuthStore().setIsLoggedIn(data),
      VUEX_IS_APP_CONFIG_FETCHED: () => AuthStore().setAppConfigFetched(data),
      VUEX_APP_CONFING: () => AuthStore().setAppConfig(data),
      VUEX_IS_USER_FETCH_FINISHED: () => AuthStore().setIsUserFetchFinished(data),
      VUEX_USER_DETAILS: () => AuthStore().setUserDetails(data),
      VUEX_UPDATE_THEME: () => AuthStore().handleThemePreference(data),
      VUEX_NOTIFICATION_PERMISSION: () => AuthStore().handleNotificationPermission(),
      VUEX_GET_TOKEN: () => AuthStore().handleGetFcmToken(),
      VUEX_AGREEMENT_POPUP: () => AgreementStore().openAgreementIfNeeded(data),
      VUEX_SET_ERROR_CODE: () => CommonStore().setErrorCode(data),
      VUEX_CURRENT_COMPANY_ID: () => AuthStore().setCurrentCompanyId(data),
      VUEX_UPDATE_CURRENT_COMPANY_INFO: () => AuthStore().setCurrentCompanyInfo(data),
      VUEX_UPDATE_TENANT_LIST: () => AuthStore().setTenantList(data),
      VUEX_UPDATE_CURRENT_TENANT_ID: () => AuthStore().setCurrentTenantId(data)
    }
    if (eventHandlers[eventType]) {
      eventHandlers[eventType]()
    }
  })
}

export function removeEventListenerFromVuexToPinia () {
  window.removeEventListener('update.pinia.state.from.vuex', eventListenerStopped)
}

function eventListenerStopped () {
  console.log('event listerning ended...')
}
